<template>
  <v-card>
    <v-form @submit.prevent="submit()" ref="editForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 class="flex-container-space-between vertical-center-container">
            <span class="headline">
              Edit
              <span class="grey--text subheading">- Tipping Docket ({{tippingDocket.id}})</span>
            </span>
            <!-- <div class="grey--text"><time-ago :time="editedTippingDocket.updatedAt" needsParse updated></time-ago></div> -->
            <v-tooltip>
              <v-btn
                icon
                flat
                slot="activator"
                :color="$store.state.global.pages.tipping.color"
                @click="$emit('openEditHeader')"
              >
                <v-icon>{{$store.state.global.pages.docket.icon}}</v-icon>
              </v-btn>
              <span>Edit Header Details</span>
            </v-tooltip>
          </v-flex>

          <flex-sub-header>Details</flex-sub-header>
          <!-- <v-flex xs12 sm6>
                            <v-text-field 
                            label="External Reference" 
                            :color="primaryNeutral"
                            v-model="editedTippingDocket.tippingDocketHeader.externalRef" 
                            :rules="detailsRules"
                            prepend-icon="note"></v-text-field>
          </v-flex>-->
          <v-flex xs12>
            <v-text-field
              label="Notes"
              :color="primaryNeutral"
              v-model="editedTippingDocket.notes"
              :rules="notesRules"
              prepend-icon="note"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              :items="statusItems"
              label="* Status"
              :color="primaryNeutral"
              v-model="editedTippingDocket.status"
              :rules="statusRules"
              prepend-icon="info"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              :items="spoils"
              label="* Spoil"
              item-text="name"
              item-value="id"
              :color="primaryNeutral"
              v-model="editedTippingDocket.spoilId"
              :rules="spoilRules"
              prepend-icon="info"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              label="* Cost Price"
              :color="primaryNeutral"
              v-model.number="editedTippingDocket.costPrice"
              :rules="costPriceRules"
              prepend-icon="attach_money"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              label="* Qty"
              :color="primaryNeutral"
              v-model.number="editedTippingDocket.qty"
              :rules="qtyRules"
              prepend-icon="add"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              disabled
              label="Cost Total"
              :value="(editedTippingDocket.qty * editedTippingDocket.costPrice).toFixed(2)"
              :color="primaryNeutral"
              :rules="[]"
              prepend-icon="attach_money"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>

        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";

import TippingService from "@/services/requests/tippingService";
import TippingValidation from "../mixins/validation";

import getSpoils from "@/services/mixins/getMasterFiles/getSpoils";

import FormatDates from "@/services/mixins/formatDates";

import DatePickerWrapper from "@/components/ui/datePickerWrapper";

import StatusItems from "../mixins/statusItems";
export default {
  mixins: [TippingValidation, getSpoils, FormatDates, StatusItems],
  components: {
    DatePickerWrapper
  },
  data() {
    return {
      editedTippingDocket: this.clone(this.tippingDocket),
      loading: false,
      prefix: "editedTippingDocket"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedTippingDocket = this.clone(this.tippingDocket);
      this.close();
    },
    submit() {
      if (!this.$refs.editForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      TippingService.updateTippingDocketLine(this.editedTippingDocket)
        .then(result => {
          this.loading = false;
          this.$store.commit("tipping/setState", {
            prop: "fetchTippingDockets",
            value: true
          });
          //this.editedTippingDocket = this.clone(result.data.result.tippingDocket);
          this.snack({
            text: "Tipping Docket line was edited!",
            color: "green"
          });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    },
    clone(obj) {
      var editedTippingDocket = Object.assign({}, obj);
      editedTippingDocket.date = this.makeComputerDate(
        editedTippingDocket.date
      );
      return editedTippingDocket;
    }
  },
  props: {
    tippingDocket: Object
  },
  computed: {
    different() {
      if (!this._.isEqual(this.tippingDocket, this.editedTippingDocket)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
</style>